import React, { useEffect, useState } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import * as appSettings from "../../services/AppSettingsService";
import Footer from "../../components/FooterComponent/Footer";
import { useLocation } from "react-router-dom";

const SITE_KEY = `${appSettings.APP_RECAPTCHA_SITEKEY()}`;
export default function FooterLayout() {
  const { pathname } = useLocation();
  const [isAuthorized, setIsAuthorized] = useState<boolean>(true);

  useEffect(() => {
    ["/Registration"].includes(pathname) && setIsAuthorized(false);
  }, []);

  return (
    <>
      {isAuthorized ? (
        <Footer isAuth={isAuthorized} />
      ) : (
        <GoogleReCaptchaProvider reCaptchaKey={SITE_KEY}>
          <Footer isAuth={isAuthorized} />
        </GoogleReCaptchaProvider>
      )}
    </>
  );
}
